import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import TableDataLayerClosed from "../components/TableDataLayerClosed";

const TableDataPageClosed = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>
        {/* TableDataLayer */}
        <TableDataLayerClosed />

      </MasterLayout>

    </>
  );
};

export default TableDataPageClosed; 
